import apiClient from './client'

export interface SportTypeField {
  field_key: string
  field_label: string
  field_type: 'text' | 'number' | 'select' | 'date'
  field_options?: string[]
  is_required: boolean
  display_order: number
}

export const sportTypesApi = {
  getFieldsBySportName: async (sportName: string): Promise<SportTypeField[]> => {
    const response = await apiClient.get(`/sport-types/${encodeURIComponent(sportName)}/fields`)
    return response.data
  },
}
